import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type BasketIconProps = CreateIconComponentProps;
export const BasketIcon: React.FC<BasketIconProps> = ({
  title = 'Basket',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.624 4.668a1 1 0 0 1 1.752 0L16.31 10H8.69l2.933-5.332ZM6.409 10 9.87 3.704c1.14-2.072 4.118-2.072 5.258 0L18.59 10H21a1 1 0 0 1 .98 1.196l-1.678 8.392A3 3 0 0 1 17.36 22H6.64a3 3 0 0 1-2.942-2.412l-1.679-8.392A1 1 0 0 1 3 10h3.409ZM7 12H4.22l1.439 7.196a1 1 0 0 0 .98.804H17.36a1 1 0 0 0 .981-.804L19.781 12H7Z"
      clipRule="evenodd"
    />
  </CreateIconComponent>
);
